
import { Vue, Options, prop } from "vue-class-component";
import Icons from "@/app/ui/components/icons/index.vue";
import LastLocationFilterSection, {
  LastLocationOptionValue
} from "../shared/last-location-filter-section.vue";
import { LastLocationOption } from "@/domain/entities/UrgentDeliveryManagement";

class Props {
  options = prop<LastLocationOption[]>({
    default: () => []
  });
}

@Options({
  components: { LastLocationFilterSection },
  emits: ["apply", "reset"]
})
class FilterHal extends Vue.with(Props) {
  isOpen = false;
  selectedLastLocations: LastLocationOptionValue[] = [];
  lastLocationHalRef: any = null;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  onApply() {
    this.isOpen = false;

    this.$emit("apply", {
      lastLocations: {
        cityCodes: this.selectedLastLocations.map((s) => s.cityCode),
        hubIds: this.selectedLastLocations.map((s) => s.hubId)
      }
    });
  }

  onReset() {
    this.selectedLastLocations = [];
    this.lastLocationHalRef?.reset();

    this.$emit("reset");
    this.isOpen = false;
  }

  get activeFilterCount(): number {
    let count = 0;

    if (this.selectedLastLocations.length) {
      count++;
    }

    return count;
  }

  get isApplyDisabled(): boolean {
    const hasLastLocation = this.selectedLastLocations.length;

    return !hasLastLocation;
  }
}

export default FilterHal;
